import React from 'react'
import PropTypes from 'prop-types'
import { Heading } from '@ui'
import styled from 'styled-components'
import { cssVariables } from '../../styles'

const AvatarContainer = styled.div`
	width: 100%;
	height: 70px;
	position: relative;
	overflow: hidden;
	padding: 5px;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	color: black;
	border: none;
	filter: ${({ isActive }) => (isActive ? 'grayscale(0%)' : 'grayscale(100%)')};
	transition: filter 0.2s, opacity 0.2s;
	transition-timing-function: ease-in-out;
	background-color: ${({ isActive }) => (isActive ? cssVariables.colors.grays.lightGray : 'unset')};
	cursor: ${({ isActive }) => (isActive ? 'not-allowed' : 'pointer')};

	&:hover {
		filter: grayscale(0%);
	}
	&:focus {
		filter: grayscale(0%);
		outline: none !important;
	}
`

const ImageContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 60px;
	min-width: 60px;
	height: 60px;
	width: 60px;
	margin-right: ${cssVariables.spacings.default};
`

const ImageLogo = styled.img`
	position: relative;
	height: auto;
	width: auto;
	max-width: 100%;
	max-height: 100%;
`

const NoImage = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2px;
	word-wrap: break-word;
	font-size: 10px;
	line-height: 17px;
	background-color: ${cssVariables.colors.brand.secondary};
	color: white;
`

const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	text-align: left;
	width: 100%;

	.Heading {
		margin: 0 0 ${cssVariables.spacings.sm};
	}
`

const Classification = styled.p`
	margin: 0;
	display: flex;
	justify-content: flex-start;
`

const ClassificationActive = styled.div`
	justify-content: space-between;
	display: flex;
`

const Active = styled.span`
	color: ${cssVariables.colors.semantic.information};
`

export const Avatar = ({ logoUrl, isActive, name, country, classification, onClick }) => {
	let logo
	if (logoUrl) {
		logo = <ImageLogo alt={`${name} logo`} src={`${logoUrl}/x1`} />
	} else {
		logo = <NoImage>{name}</NoImage>
	}

	const classificationString = `${
		!classification ? '' : `${classification.name}${!classification.child ? '' : ` > ${classification.child.name}`}`
	}`

	return (
		<AvatarContainer
			aria-hidden
			isActive={isActive}
			onClick={() => {
				if (!isActive) {
					onClick()
				}
			}}
		>
			<ImageContainer className="ImageContainer">{logo}</ImageContainer>
			<TextContainer>
				<Heading three>
					{name} ({country})
				</Heading>
				<ClassificationActive>
					<Classification>{classificationString}</Classification>
					{isActive && <Active>Active merchant</Active>}
				</ClassificationActive>
			</TextContainer>
		</AvatarContainer>
	)
}

Avatar.propTypes = {
	logoUrl: PropTypes.string,
	isActive: PropTypes.bool,
	name: PropTypes.string.isRequired,
	country: PropTypes.string.isRequired,
	classification: PropTypes.shape({
		name: PropTypes.string.isRequired,
		child: PropTypes.shape({
			name: PropTypes.string.isRequired,
			child: PropTypes.shape({
				name: PropTypes.string.isRequired,
			}),
		}),
	}),
	onClick: PropTypes.func,
}
